import { render, staticRenderFns } from "./Chair.vue?vue&type=template&id=0d7835d3&"
import script from "./Chair.vue?vue&type=script&lang=js&"
export * from "./Chair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports